import ReactPlaceholder from "react-placeholder";
import "react-placeholder/lib/reactPlaceholder.css";
import { useHotelInfo } from "../../hooks/useHotelInfo";
import Accommodation from "./Accommodation";
import HotelSummary from "./HotelSummary";
import Transport from "./Transport";
import TicketsInfo from "./TicketsInfo";
import Dining from "./Dining";
import Freebies from "./Freebies";
import { formatCurrency, getGeo } from "../../utils/formatCurrency";

const HotelMiniCart = ({ styles }) => {
  const { isSuccess, data: hotelData } = useHotelInfo();

  const formatPriceWithCurrency = (price) => {
    const geo = getGeo();
    return formatCurrency(price, geo);
  }

  return (
    <ReactPlaceholder
      showLoadingAnimation
      ready={isSuccess}
      type="text"
      rows={10}
    >
      {isSuccess && (
        <div className={styles.hotelsBasket}>
          <Accommodation
            accommodation={hotelData.accommodation}
            transport={hotelData.transport}
            styles={styles}
          />
          <HotelSummary
            hotelSummary={hotelData.hotel_summary}
            transport={hotelData.transport}
            styles={styles}
            formatPriceWithCurrency={formatPriceWithCurrency}
          />
          <Transport
            transport={hotelData.transport}
            styles={styles}
          />
          <TicketsInfo
            tickets_info={hotelData.tickets_info}
            styles={styles}
            formatPriceWithCurrency={formatPriceWithCurrency}
          />
          <Dining
            dining={hotelData.dining}
            styles={styles}
            formatPriceWithCurrency={formatPriceWithCurrency}
          />
          <Freebies
            freebies={hotelData.freebies}
            styles={styles}
          />
        </div>
      )}
    </ReactPlaceholder>
  );
};

export default HotelMiniCart;
